var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-layout',{attrs:{"view":"lHh Lpr lFf"}},[_c('q-page-container',{staticClass:"bg-primary-g"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }